export const headingSideHorizontalBorder = function() {
	const iframe = document.querySelector('iframe[name=editor-canvas]');
	const parent = iframe ? iframe.contentWindow.document : document;

	parent.querySelectorAll(".is-style-heading-side-horizontal-border").forEach(function(element) {
		element.style.removeProperty("--ns-heading-side-right-border--width");
		element.style.removeProperty("--ns-heading-side-right-border--right");
		element.style.removeProperty("--ns-heading-side-right-border--top");
		element.style.removeProperty("--ns-heading-side-right-border--display");
		element.style.removeProperty("--ns-heading-side-left-border--width");
		element.style.removeProperty("--ns-heading-side-left-border--left");
		element.style.removeProperty("--ns-heading-side-left-border--top");
		element.style.removeProperty("--ns-heading-side-left-border--display");

		if ( element.tagName.match(/^h[1-6]$/i ) ) {
			const fontSize = window.getComputedStyle(element).fontSize;
			const lineHeight = window.getComputedStyle(element).lineHeight;

			if (fontSize.endsWith("px") && lineHeight.endsWith("px")) {
				const fontSizeVal = parseInt(fontSize, 10);
				const wrap = element.closest(".wp-site-blocks") || element.closest(".is-root-container");

				if (wrap) {
					const wrapRect = wrap.getBoundingClientRect();
					const elementRect = element.getBoundingClientRect();

					const wrapLeft = wrapRect.left + window.scrollX;
					const wrapRight = wrapRect.right + window.scrollX;
					const elementLeft = elementRect.left + window.scrollX;
					const elementRight = elementRect.right + window.scrollX;

					if (element.classList.contains("has-text-align-center")) {

					} else if (element.classList.contains("has-text-align-right")) {
						const borderLength = 0 < (wrapRight - elementRight - fontSizeVal) ? (wrapRight - elementRight - fontSizeVal) : (wrapRight - elementRight) * 0.5;
						element.style.setProperty("--ns-heading-side-right-border--width", borderLength + "px");
						element.style.setProperty("--ns-heading-side-right-border--right", (elementRight - wrapRight) + "px");
						element.style.setProperty("--ns-heading-side-right-border--top", Math.floor(fontSizeVal / 2) + "px");
						element.style.setProperty("--ns-heading-side-right-border--display", "block");
					} else {
						const borderLength = 0 < (elementLeft - wrapLeft - fontSizeVal) ? (elementLeft - wrapLeft - fontSizeVal) : (elementLeft - wrapLeft) * 0.5;
						element.style.setProperty("--ns-heading-side-left-border--width", borderLength + "px");
						element.style.setProperty("--ns-heading-side-left-border--left", (wrapLeft - elementLeft) + "px");
						element.style.setProperty("--ns-heading-side-left-border--top", Math.floor(fontSizeVal / 2) + "px");
						element.style.setProperty("--ns-heading-side-left-border--display", "block");
					}
				}
			}
		}
	});
};
